import { render, staticRenderFns } from "./QuranDetail.vue?vue&type=template&id=7c144815&"
import script from "./QuranDetail.vue?vue&type=script&lang=js&"
export * from "./QuranDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports